import { NotificationAlertErrorShieldSolidIcon } from '@tableau/icons/NotificationAlertErrorShieldSolidIcon';
import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { learnMoreStyle } from '~src/settings/styles/CommonStyles';
import { cssClass } from '~src/style';

import { Alert } from '../types/Alert';
import { alertIconClass } from './AlertDetailsPopover';

export type AlertDetailsBodyEntryProps = Readonly<{
    alert: Alert;
}>;

export function AlertDetailsBodyEntry(props: AlertDetailsBodyEntryProps) {
   const { alert } = props;

  return (
    <table >
        <tbody>
            <tr>
                <td>
                    <NotificationAlertErrorShieldSolidIcon size={14} alt={''} className={alertIconClass} />
                    <span className={alertTitleText}><b>{alert.alertName}</b></span>
                </td>
            </tr>
            <tr>
                <td><span className={alertText}>{alert.createdAt}</span></td>
            </tr>
                <tr>
                <td>
                    <span className={alertText}>{alert.alertDescription}
                        <TextLinkWidget testId={'DataConnect-ClusterAlert-learn-more'}
                            className={learnMoreStyle}
                            href={HelpService.getServerHelpUrlByCategory('DataConnect-ClusterAlert')}
                            target={'_blank'}>
                            {Messages.siteRemoteAgentSettingsLearnMore()}
                        </TextLinkWidget>
                    </span>
                </td>
            </tr>
        </tbody>
    </table>
  );
}

const alertText = cssClass('alert', 'text', {
    verticalAlign: 'middle',
    paddingLeft: 20,
    display: 'block'
  });

  const alertTitleText = cssClass('alert-title', 'text', {
    verticalAlign: 'middle',
    paddingLeft: 2
  });
